import { Autocomplete, TextField } from '@mui/material';
import { FC, memo } from 'react';
import { PlaceEntity } from 'src/entities/placeEntity';

interface PlaceAutocompleteProps {
  label: string;
  id: string;
  placeData: PlaceEntity[];
  selectedPlaceId: number | null;
  onPlaceChange: (placeId: number | null) => void;
  loading?: boolean;
}

const PlaceAutocomplete: FC<PlaceAutocompleteProps> = memo(({
  label,
  id,
  placeData,
  selectedPlaceId,
  onPlaceChange,
  loading = false
}) => (
  <Autocomplete
    freeSolo
    options={placeData.map((d) => ({
      ...d,
      label: d.name
    }))}
    loading={loading}
    value={placeData.find((it) => it.id === selectedPlaceId)?.name || ''}
    onChange={(_, value) => {
      if (typeof value === 'object' && value !== null) {
        onPlaceChange(value.id);
      } else if (typeof value === 'string') {
        const place = placeData.find((it) => it.name === value);
        if (place) {
          onPlaceChange(place.id);
        } else {
          // 選択肢にない値の場合はIDをnullに設定
          onPlaceChange(null);
        }
      } else {
        onPlaceChange(null);
      }
    }}
    onInputChange={(_, value) => {
      const place = placeData.find((it) => it.name === value);
      if (place) {
        onPlaceChange(place.id);
      } else {
        // 選択肢にない値の場合はIDをnullに設定
        onPlaceChange(null);
      }
    }}
    multiple={false}
    fullWidth
    renderInput={(params) => {
      const currentValue = params.inputProps.value as string;
      const isValidPlace = !currentValue || placeData.some((place) => place.name === currentValue);

      return (
        <TextField
          {...params}
          margin="dense"
          type="text"
          fullWidth
          label={label}
          id={id}
          InputLabelProps={{ shrink: true }}
          error={!isValidPlace}
          helperText={!isValidPlace ? '選択肢から有効な地点を選択してください' : ''}
        />
      );
    }}
  />
));

export default PlaceAutocomplete;
